import React, { useRef, useState } from 'react';

import { Box, Button, StackView, TextInput, Typography } from '@telus-uds/components-web';

import StatusBar from './statusBar';

import request from '../utils/request';
import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';

const ExistingPhoneNumberCheck = () => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    portabilityTool: {
      labelPortabilityCheck,
      labelNpaNxx,
      hintNpaNxx,
      buttonClear,
      buttonCheck,
      canBePorted,
      cannotBePorted
    }
  } = localizedStrings;

  const [status, setStatus] = useState({
    isVisible: false,
    type: '',
    text: ''
  });
  const inputRef = useRef();
  const handleCheck = () => {
    const valuePhoneNumber = inputRef.current.value;

    if (valuePhoneNumber) {
      request
        .get(`/check-phone?phone=${valuePhoneNumber.replaceAll('-', '')}`)
        .then(response => {
          if (response && response.status === 200) {
            if (response.data && response.data.exists) {
              setStatus({
                type: 'success',
                isVisible: true,
                text: canBePorted
              });
            } else {
              setStatus({
                type: 'error',
                isVisible: true,
                text: cannotBePorted
              });
            }
          } else {
            setStatus({
              type: 'error',
              isVisible: true,
              text: `Response Error`
            });
          }
        })
        .catch(err => {
          setStatus({ type: 'error', isVisible: true, text: err.message });
        });
    }
  };

  const onClear = () => {
    inputRef.current.value = '';
    setStatus({
      ...status,
      isVisible: false
    });
  };

  return (
    <StackView space={3}>
      <Typography heading="h2" variant={{ size: 'h2' }} block>
        {labelPortabilityCheck}
      </Typography>
      <Box tag="fieldset" between={2}>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div style={{ width: '50%' }}>
            <TextInput
              ref={inputRef}
              label={labelNpaNxx}
              hint={hintNpaNxx}
            />
          </div>
          <div style={{ display: 'flex', gap: '1rem', marginTop: '1rem', marginLeft: '8rem' }}>
            <Button variant = {{ priority: 'high' }} onPress={handleCheck}>{buttonCheck}</Button>
            <Button onPress={onClear}>{buttonClear}</Button>
          </div>
        </div>
        <div
          style={{
            marginTop: '1rem'
          }}
        >
          {status.isVisible && (
            <StatusBar status={status} setStatus={setStatus} />
          )}
        </div>
      </Box>
    </StackView>
  );
};

export default ExistingPhoneNumberCheck;
